import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'



const DailyBurnGoalChart = ({
    chartData = [],
    chartLabel,
    fieldsLabel = "",
    height = 350,
    purpose = "",
    actualLabel = "Actual Hours",
    xAxisTitle= '',
    yAxisTitle= '',
    remainingLabel = "Remaining Hours",
}) => {

    const option = {

        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },

            formatter: (params) => {
                const item = chartData[params[0].dataIndex];
                let html = "";
                if (purpose) {
                    html += `<b>Purpose</b><br/>${purpose}<br/><br/>`;
                }

                html += `<b>${item.resourceName}</b><br/>`;

                html += `<b>${actualLabel}</b> : ${item.actualHours} hrs<br/>`;
                html += `<b>${remainingLabel}</b> : ${item.remainingHours} hrs<br/>`;
                html += `<b>Target Hours</b> : ${item.targetHours} hrs<br/>`;
                html += `<b>Burn %</b> : ${item.burnPercentage}%<br/>`;
                html += `<b>Total Tasks</b> : ${item.totalTasks}`;

                return html;
            },
        },

        legend: {
            show: true,
            top: 5,
            left: "center",
            itemWidth: 18,
            itemHeight: 12,
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
            data: [
                actualLabel,
                remainingLabel,
            ],
        },

        grid: {
            left: 0,
            right: 20,
            top: 50,
            bottom: 25,
            containLabel: true,
        },

        xAxis: {
            type: "category",
            name: xAxisTitle,
            nameLocation: 'middle',
            nameGap: 25,
            data: chartData.map(item => item.resourceName),
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 0,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            splitLine: {
                show: false,
            },
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
        },

        yAxis: {
            type: "value",
            max: 8,
            show: true,
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 25,
            splitLine: {
                show: false,
            },
             nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisTick: {
                show: false,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisLabel: {
                show: true,
                width: 30,
                overflow: "break",
                lineHeight: 18,
                color: labelColor,
                fontSize: 11,
                rotate: 0,
            }
        },

        // series: [
        //     {
        //         name: actualLabel,
        //         type: "bar",
        //         // stack: "hours",
        //         data: chartData.map(item => item.actualHours),
        //         barWidth: 55,
        //         itemStyle: {
        //             color: "#17B890",
        //         },
        //     },

        //     {
        //         name: remainingLabel,
        //         type: "bar",
        //         // stack: "hours",
        //         data: chartData.map(item => item.remainingHours),
        //         barWidth: 55,
        //         itemStyle: {
        //             color: "#6EE7B7",
        //             borderRadius: [8, 8, 0, 0],
        //         },
        //     },

        // ],

        series: [
            {
                name: actualLabel,
                type: "bar",
                data: chartData.map(item => item.actualHours),
                barWidth: 25,
                barGap: "0%",
                itemStyle: {
                    color: "#03775a",
                    borderRadius: [8, 8, 0, 0],
                },
            },
            {
                name: remainingLabel,
                type: "bar",
                data: chartData.map(item => item.remainingHours),
                barWidth: 25,
                itemStyle: {
                    color: "#0bda87",
                    borderRadius: [8, 8, 0, 0],
                },
            },
        ]
    };

    return (

        <ChartCard
            title={chartLabel}
            fields={fieldsLabel}
            height={height}
        >

            <ReactECharts
                option={option}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />

        </ChartCard>

    );
};

export default DailyBurnGoalChart;